import React from 'react'
import { Flex, Spinner } from '@chakra-ui/core'

export const Loader = ({ mt, maxWidth = '600px' }: any) => (
  <Flex justifyContent="center" maxWidth={maxWidth} mt={mt} p="10px">
    <Spinner size="xl" />
  </Flex>
)
